var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVasecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 1.25v9.5M10 6c0 2.454-2.677 4.24-3.651 4.807a.798.798 0 0 1-.244.114.569.569 0 0 1-.21 0 .804.804 0 0 1-.244-.114C4.677 10.24 2 8.454 2 6V3.61c0-.4 0-.6.065-.772a1 1 0 0 1 .274-.394c.138-.122.325-.192.7-.332l2.68-1.006c.104-.039.156-.058.21-.066a.5.5 0 0 1 .143 0c.053.008.105.027.209.066l2.68 1.006c.375.14.562.21.7.332a1 1 0 0 1 .274.394C10 3.01 10 3.21 10 3.61V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVasecurity);
export default __webpack_public_path__ + "static/media/vasecurity.9d7db1f846c86a00def5831b74b9294a.svg";
export { ForwardRef as ReactComponent };